import { EUserType } from 'shared/models';
import { IImage, IVideo } from '../media';
import { IUserAuthInfo } from 'shared/models/user-auth-info';
import { Region } from '@lemon8/web-app-shared/i18n';

export enum EPostSeoBanStatus {
  Unknown = 0,
  PrivateAuthor = 1,
  AuthorUnderAge = 2,
  ErrVisibility = 3,
  ErrPermission = 4,
}

export enum ECommentPermission {
  All = 0, // 显示评论区
  Follower = 1, // 粉丝可评论
  Self = 2, // 自己可评论
  Disable = 3, // 不可评论，不显示评论区
  Friend = 4, // 好友可评论
}

export interface GalleryLabelType {
  direction: string;
  id: string;
  imageIndex: number;
  name: string;
  type: string;
  xPct: number;
  yPct: number;
}

export enum EArticleClass {
  GALLERY = 'Gallery',
  VIDEO = 'Video',
  ARTICLE = 'Article',
}

export enum EWarningLabelType {
  DANGER = 101,
  DANGER_PROFESSIONAL = 102,
  COSMETIC_SURGERY = 103,
  SHOCKING = 401,
  ELECTION = 10001,
}

export interface IIllegalInfo {
  warningLabel: string;
  warningLabelType: EWarningLabelType;
}

export interface IArticleDetail {
  groupId: string;
  templateId?: string;
  imprId?: string;

  // author
  author: {
    userId: string;
    avatar: string;
    authInfo: IUserAuthInfo;
    nickName: string;
    linkName: string;
    followerCount: number;
    userType: EUserType;
  };

  // content
  articleClass: EArticleClass;

  // TODO cast to i18n:Region
  articleRegion: Region;
  title: string;
  content: string;
  shortContent: string;

  translatedRegions?: string[];
  isTranslatedVersion?: boolean;

  gptSummary?: string;

  // content publish time
  publishTime: number;
  modifyTime?: number;

  // interaction
  readCount: number;
  diggCount: number;
  favoriteCount: number;
  commentCount: number;

  // legacy hashtag
  forumList?: {
    id: string;
    name: string;
  }[];

  // AI text on SimpleModal
  popupContent?: {
    description: string;
    buttonOpen: string;
  };

  // poi
  locationInfo?: {
    poiId: string;
    poiName: string;
  };

  // search after read
  relatedQuery?: string;
  relatedQueryInfos: { word: string }[];

  commentPermission: ECommentPermission;
  illegalInfo?: IIllegalInfo;
  seoBan?: EPostSeoBanStatus;
}

export interface IVideoArticleDetail extends IArticleDetail {
  articleClass: EArticleClass.VIDEO;
  largeImage: IImage;
  video: IVideo & { encryptedUrl?: string; ocr?: string[] };
}

export interface IGalleryArticleDetail extends IArticleDetail {
  articleClass: EArticleClass.GALLERY;
  imageList: IImage[];
  galleryLabels: GalleryLabelType[];
  ocrText?: string[]; // ocr识别文字
  imageAutoGenDesp?: string[]; // 图片描述自动生成
}

export interface IRichArticleDetail extends IArticleDetail {
  articleClass: EArticleClass.ARTICLE;
  largeImage: IImage;
}

export type TArticleDetail = IVideoArticleDetail | IGalleryArticleDetail | IRichArticleDetail;
